import React from "react";
import { LanguageService } from "../../services/languageService";
import "./footer.scss";
import { footer, footer_en, footer_mb, footer_mb_en } from "../../asset/images";

const Footer = () => {
  const lang = LanguageService.detectLanguage();
  const isVi = lang === "vi";

  return (
    <div className="footer">
      <div className="pc">
        <img src={isVi ? footer : footer_en} alt="Footer" />
      </div>
      <div className="mobile">
        <img src={isVi ? footer_mb : footer_mb_en} alt="Footer Mobile" />
      </div>
      <div className="footer-links">
        <a href="https://tos.mu.world/contact-us.shtml">Contact</a> | <a href="https://tos.mu.world/privacy.shtml">Privacy Policy</a> | <a href="https://tos.mu.world/conditions.shtml">Terms of Service</a> | <a href="https://tos.mu.world/refunds.shtml">Refund Policy</a>
      </div>
    </div>
  );
};

export default Footer;
